import cryptoService from '../../../services/cryptoService';
import { CHAT_MESSAGE_TYPES } from '../../../utils/constants';
import { getAllChatRooms, getChatRoom } from './asyncThunks';

export const getAllChatRoomsBuilder = builder => {
  builder.addCase(getAllChatRooms.pending, state => {
    state.getAllChatRoomsPending = true;
  });
  builder.addCase(getAllChatRooms.fulfilled, (state, { payload }) => {
    const { data, page, maxReached, total } = payload;
    let anyUnseenMessage = false;

    for (const chatRoom of data) {
      if (chatRoom.unseenMessage) {
        anyUnseenMessage = true;
      }
    }

    // let formattedData = data.map(chatRoom => {
    //   let messageSeen = false;
    //   const me = chatRoom.chatRoomMembers.find(member => member.user === null);
    //   console.log(chatRoom.chatRoomMembers);
    //   const youSendLastMessage = !chatRoom.messages[0]?.userId;
    //   if (chatRoom.messages.length) {
    //     messageSeen = chatRoom.messages[0]?.id > me?.lastSeenMessageId && !youSendLastMessage;
    //     if (!anyUnseenMessage) {
    //       anyUnseenMessage = messageSeen;
    //     }
    //   }
    //   // return { ...chatRoom, unseenMessage: messageSeen };
    //   return { ...chatRoom };
    // });

    if (page !== 1) {
      state.chatRooms.data = [...state.chatRooms.data, ...data];
    } else {
      state.chatRooms.data = data;
    }
    state.hasUnSeenMessages = anyUnseenMessage;
    state.chatRooms.page = page;
    state.chatRooms.maxReached = maxReached;
    state.chatRooms.total = total;
    state.getAllChatRoomsPending = false;
  });
  builder.addCase(getAllChatRooms.rejected, state => {
    state.getAllChatRoomsPending = false;
  });
};

export const geChatRoomBuilder = builder => {
  builder.addCase(getChatRoom.pending, state => {
    state.getChatRoomPending = true;
  });
  builder.addCase(getChatRoom.fulfilled, (state, { payload }) => {
    const { data, client, maxReached, page, id, key } = payload;

    const decryptedData = data.map(message => {
      if (message.type === CHAT_MESSAGE_TYPES.PLAIN_TEXT) {
        message.message = cryptoService.decrypt(key, message.message.message);
      }
      return message;
    });

    if (page !== 1) {
      state.chatRoom.data = [...state.chatRoom.data, ...decryptedData];
    } else {
      state.chatRoom.data = decryptedData;
    }
    state.chatRoom.maxReached = maxReached;
    state.chatRoom.page = page;
    state.chatRoom.id = id;
    state.chatRoom.client = client;
    state.chatRoom.key = key;
    state.getChatRoomPending = false;

    let messageSeen = false;

    for (const [i, chatRoom] of state.chatRooms.data.entries()) {
      if (chatRoom.id === id) {
        chatRoom.unseenMessage = false;
        // for (const [v, chatRoomMember] of state.chatRooms.data[i].chatRoomMembers.entries()) {
        //   console.log(chatRoomMember);
        //   if (chatRoomMember.vendor && data[0]) {
        //     state.chatRooms.data[i].chatRoomMembers[v].lastSeenMessageId = data[0].id;
        //   }
        // }
      }
      // const me = chatRoom.chatRoomMembers.find(member => member.user === null);
      // const youSendLastMessage = !chatRoom.messages[0]?.userId;

      if (chatRoom.messages.length) {
        if (chatRoom.unseenMessage) {
          messageSeen = true;
        }
      }
    }

    state.hasUnSeenMessages = messageSeen;
  });
  builder.addCase(getChatRoom.rejected, state => {
    state.getChatRoomPending = false;
  });
};
